<!-- NB: Seul les certificats moodle sont affichés sur ce template (voir ligne 67) -->
<div class="w-full p-8 bg-zinc-100 flex-col justify-start items-start gap-2.5 inline-flex">
  <app-breadcrumb [items]="breadcrumbItems"></app-breadcrumb>
  <div class="self-stretch h-full flex-col justify-start items-start gap-[60px] flex">
    <div class="self-stretch rounded-lg bg-white shadow-sm p-6 px-8">
      <div
        class="self-stretch h-[66px] flex-col justify-start items-center gap-6 flex">
        <div
          class="self-stretch h-[66px] flex-col justify-start items-start gap-6 flex">
          <div
            class="self-stretch h-[66px] flex-col justify-start items-start gap-5 flex">
            <div class="self-stretch justify-start items-start gap-4 inline-flex">
              <div
                class="grow shrink basis-0 flex-col justify-start items-start gap-1 inline-flex">
                <div
                  class="self-stretch text-gray-900 text-4xl font-semibold leading-[38px]">
                  Liste des certificats
                </div>
                <div
                  class="self-stretch text-slate-600 text-base leading-normal mt-4 mb-8">
                  Vous trouverez ici la liste des certificats disponibles
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div
        class="self-stretch h-full flex-col justify-start items-center gap-4 flex"
      >

        <div class="self-stretch w-full h-full flex-col justify-start items-start gap-8 flex">
          <div
            class="self-stretch w-full  h-full flex-col justify-start items-start gap-4 flex"
          >
            <div
              class="tableau-ctnr certificats w-full  self-stretch h-full flex-col justify-start items-start gap-4 flex"
            >

              <table class="mat-elevation-z8 w-full mt-8 text-base tableau text-left rtl:text-right text-gray-500 dark:text-gray-400 ">
                <thead class="text-md text-gray text-black" style="background-color:#c3c9d0">
                <tr>

                  <th scope="row" class="px-6 py-3">
                    Certificats
                  </th>
                  <th scope="row" class="px-6 py-3">
                    Cohorte
                  </th>
                  <th scope="row" class="px-6 py-3">
                    Ouverture
                  </th>
                  <th scope="row" class="px-6 py-3">
                    Clôture
                  </th>
                  <th scope="row" class="px-6 py-3">
                    État
                  </th>
                  <!--    <th scope="col" class="px-6 py-3">
                       Gérer
                    </th> -->
                </tr>
                </thead>
                <!--Call spinner-->

                <tbody>
                <tr class="bg-white border-b dark:bg-gray-800 dark:border-gray-700" *ngFor="let certificat of MoodleCertificats">
                  <th data-label="Certificats" scope="row" class="px-6 py-4 font-semibold certificat text-gray-900 whitespace-nowrap dark:text-white">
                    {{ certificat.fullname}}
                  </th>
                  <td data-label="Cohorte" class="px-6 py-4">
                    <div  class="rounded-lg p-1 px-2 text-black text-sm font-semibold pastille text-center inline-block"
                          [style.backgroundColor]="
                         '#E8F0F8'
                        ">
                      {{ certificat.shortname}}
                    </div>
                  </td>
                  <td data-label="Ouverture" class="px-5 py-4 font-semibold">
                    {{ certificat.startdate*1000 | date: 'MM/dd/yyyy'}}
                  </td>
                  <td data-label="Clôture" *ngIf="certificat.enddate != 0" class="px-5 py-4 font-semibold">
                    {{ certificat.enddate*1000 | date: 'MM/dd/yyyy'}}
                  </td>
                  <td data-label="Clôture" *ngIf="certificat.enddate == 0  || certificat.enddate == undefined " class="px-6 py-4 font-semibold">
                    N/A
                  </td>
                  <td data-label="Etat" class="px-4 py-4">
                    <div  class="etat pastille rounded-lg p-1 px-2 text-sm text-center font-semibold inline-block"
                          [style.backgroundColor]="
                          certificat.status == 'En cours'
                            ?  '#18A0FB'
                            : certificat.status == 'Terminé'
                            ?  '#79D99C'
                            : '#f04438'
                        "
                          [style.color]="
                        certificat.status == 'En cours'
                          ?  '#ffffff'
                          : certificat.status == 'Terminé'
                          ?  '#027A48'
                          : '#ffffff'
                        ">
                      {{certificat.status}}
                    </div>
                  </td>

                </tr>
                </tbody>
              </table>
              <div class="self-stretch flex justify-center mt-4">
                <mat-paginator
                  [length]="totalElementsMoodle"
                  [pageSize]="pageSizeMoodle"
                  [pageSizeOptions]="pageSizeOptions"
                  [pageIndex]="currentPageMoodle"
                  (page)="onPageChangeMoodle($event)"
                  showFirstLastButtons>
                </mat-paginator>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
